import React from 'react'
import ErrorPage from './ErrorPage'

class ErrorBoundary extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            error: null
        }
    }

    static getDerivedStateFromError(error) {
        return { hasError: true, error: error }
    }

    render() {
        if (this.state.error) {
            return <ErrorPage error={this.state.error} />
        } else {
            return this.props.children
        }
    }
}

export default ErrorBoundary